<div class="page-body" >
  <div class="row">
    <div class="col-sm-12">
      <app-card [title]="'global.overview'|translate"
                [cardOptionBtnIcon]="'fa fa-repeat'"
                [cardOptionBtn]="false"
                [advanceButton]="true"
                [advancedButtons]="advancedButtons"
                (outputButtonAdvance)="calFunction($event)"
      >
        <app-grid [buttonViewChange]="true"  [grid]="grid"  (sendParameters)="setParams($event)"></app-grid>
      </app-card>
    </div>
  </div>
</div>
<a #downloadLink href="" download style="display: none"></a>
<ng-template #expectedDeliveryWeekTemp let-row="row" let-value="value" let-column="column">
  {{row.expectedDeliveryWeek ? (row.expectedDeliveryWeek|WeekDateFormat) : ''}}
</ng-template>
<app-modal-basic #cancelModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.cancel_quote' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="cancelModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.cancel_quote_body' | translate}}: <b [innerHTML]="orderReference"></b></p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="cancelModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="cancelQuote()">{{'global.yes'|translate}}</button>
  </div>
</app-modal-basic>
<ng-template #customerPriceTemp let-row="row" let-value="value" let-column="column">
  {{row.totalCost.totalCustomerCost | BackofficeCurrency}}
</ng-template>

<ng-template #remainingTimeTemp let-row="row" let-value="value" let-column="column">
  <span class="danger" *ngIf="row.remainingDays > 0 && row.remainingDays <= 5">{{row.remainingDays + ' ' + ('global.days' | translate)}}</span>
  <span *ngIf="row.remainingDays > 5">{{row.remainingDays + ' ' + ('global.days' | translate)}}</span>
  <span class="disabled" *ngIf="row.remainingDays <= 0">{{'global.expired' | translate}}</span>
</ng-template>
